import { render, staticRenderFns } from "./PayOrderPopup.vue?vue&type=template&id=2cd5c8e0&scoped=true"
import script from "./PayOrderPopup.vue?vue&type=script&lang=js"
export * from "./PayOrderPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd5c8e0",
  null
  
)

export default component.exports